import { render, staticRenderFns } from "./HoursLink.vue?vue&type=template&id=4ec2a50a&scoped=true"
import script from "./HoursLink.vue?vue&type=script&lang=js"
export * from "./HoursLink.vue?vue&type=script&lang=js"
import style0 from "./HoursLink.vue?vue&type=style&index=0&id=4ec2a50a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec2a50a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec2a50a')) {
      api.createRecord('4ec2a50a', component.options)
    } else {
      api.reload('4ec2a50a', component.options)
    }
    module.hot.accept("./HoursLink.vue?vue&type=template&id=4ec2a50a&scoped=true", function () {
      api.rerender('4ec2a50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/HoursLink.vue"
export default component.exports